import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 
import Box from '@mui/material/Box';
import Button from '../../../general/inputs/Button';
import { deleteConsultationNote, getConsultationNotes, updateConsultation } from '../../../../routes/doctor/consultation';
import { setIsNoteDeletionPopupOpened, setIsRefreshTabs, setNotes, setNotesLength } from '../../../../redux/features/doctor/Dashboard/consultation/consultation';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import { resetConsultationNote, DefaultPatientInfoLabels } from '../../../../redux/features/doctor/Dashboard/consultation/consultationNote';
import CancelButton from '../../../general/inputs/CancelButton';


interface Props { 

}; 

const NoteDeletion: React.FC<Props> = ({ }) => {
    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 
    const isMobile = useMediaQuery('(max-width: 768px)');

    const { consultationId, consultationNoteId } = useParams(); 

    const colors = useAppSelector(state => state.theme.colors); 

    // -- 

    const handleNoteDeletion = async () => { 
        const res = await deleteConsultationNote(consultationNoteId) as any; 

        if (res.data.status == 200) { 
            const translatedLabels: DefaultPatientInfoLabels = {
                name: t('pdf.label.name', 'Name:'),
                dob: t('pdf.label.dob', 'DOB:'),
                healthCard: t('pdf.label.healthCard', 'Health Card:'),
            };
            dispatch(resetConsultationNote({ labels: translatedLabels })); 

            dispatch(setNotificationMessage(t('noteDeleted'))); 

            const result = await getConsultationNotes(consultationId) as any;
    
            if (result?.data.status === 200) { 
                dispatch(setNotes(result.data.consultationNotes)); 
                navigate(`/consultation/${consultationId}/note/${result.data.consultationNotes[0]._id}`);
                window.location.reload(); 
            }; 

            dispatch(setIsNoteDeletionPopupOpened(false)); 
        }; 
    }; 

    // -- 

    const handleQuit = () => { 
        dispatch(setIsNoteDeletionPopupOpened(false)); 
    }; 
    
    // -- 

    return (
        <Box 
            onClick={handleQuit}
            sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                width: '100vw',
                height: '100vh', 
                backgroundColor: colors?.popup, 
                overflow: 'hidden', 
                position: 'absolute', 
                zIndex: 100000000,
        }}>
            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center', 
                    justifyContent: 'space-evenly',
                    textAlign: 'center', 
                    width: '100%',
                    maxWidth: isMobile ? '90vw' : '400px', 
                    padding: isMobile ? 2 : 3, 
                    borderRadius: isMobile ? 4 : 5,
                    fontSize: 14,
                    backgroundColor: colors?.container,
                }}
            >
                <Box
                    component="img"
                    sx={{
                        width: isMobile ? 80 : 100,
                        marginTop: 2, 
                        marginBottom: 2, 
                    }}
                    src={require('../../../../assets/icons/consultation/delete-note.png')}
                />
                <Box
                    sx={{ 
                        width: '90%',
                        marginBottom: 3 
                    }}
                >{t('deleteNoteWarning')}
                </Box>
                <Button 
                    title={'delete'}
                    triggerFunction={handleNoteDeletion}
                    extraStyle={{ 
                        width: '80%', 
                        marginBottom: 2,
                        backgroundColor: colors?.red,
                        '&:hover': { 
                            color: 'white',
                            backgroundColor: 'rgb(232, 98, 30)'
                        }
                    }}
                />
            </Box>
            <CancelButton handler={handleQuit} />
        </Box>
  );
};

export default NoteDeletion;